import {createAxiosInstance} from './base.api'

const projectResourceApi = 'projectResources'

export const getProjectResource = (id, errorMethod) => createAxiosInstance(projectResourceApi).get(`/${id}`)
.catch(error => errorMethod(error))

export const updateProjectResource = (id, projectResource, successMethod, errorMethod) => createAxiosInstance(projectResourceApi).put(`/${id}`, projectResource)
.then(response => successMethod(response))
.catch(error => errorMethod(error))